import type { Entity } from '@api/api/entity-schema';
import type { DetailedInsight } from '@api/api/insights';

import styles from './InsightsDrawerContent.module.scss';
import {
  getInsightDrawerCategoryLabel,
  getInsightDrawerReferenceLabel,
} from './insightDrawerCategoryRowUtils';

interface DefaultInsightDrawerCategoryRowProps {
  insight: DetailedInsight;
  variant?: 'default';
}

interface MetadataInsightDrawerCategoryRowProps {
  entity: Entity;
  insight: DetailedInsight;
  variant: 'metadata';
}

export type InsightDrawerCategoryRowProps =
  | DefaultInsightDrawerCategoryRowProps
  | MetadataInsightDrawerCategoryRowProps;

export const InsightDrawerCategoryRow = (
  props: InsightDrawerCategoryRowProps
) => {
  const categoryLabel = getInsightDrawerCategoryLabel(props.insight);

  if (props.variant === 'metadata') {
    const referenceLabel = getInsightDrawerReferenceLabel(
      props.insight,
      props.entity
    );

    return (
      <>
        {categoryLabel}
        {referenceLabel && <> {referenceLabel}</>}
      </>
    );
  }

  return (
    <p
      data-testid="insight-drawer-category-row"
      className={styles.insightCategoryRow}
    >
      {categoryLabel}
    </p>
  );
};
